module.exports = __webpack_public_path__ + "2.jpg?a65cdd8cef2bc9ffb958145ae4ac19e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/2.jpg
// module id = 57
// module chunks = 0